import { withAuthUser } from 'next-firebase-auth'
import { TypingPractice } from 'views/typing-practice'

export default withAuthUser()(TypingPractice)
